import { render, staticRenderFns } from "./EditTemp.vue?vue&type=template&id=3f6410ae&scoped=true"
import script from "./EditTemp.vue?vue&type=script&lang=js"
export * from "./EditTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6410ae",
  null
  
)

export default component.exports